import React, { useState } from 'react';
import { PageHeader } from '../components/ui/PageHeader';
import { Card } from '../components/ui/Card';
import { MessageCircleIcon, PhoneIcon, MailIcon, HelpCircleIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function Support() {
  return <div data-id="element-578">
      <PageHeader title="Support" description="Get help with your account and services" data-id="element-579" />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-580">
        <div className="lg:col-span-2" data-id="element-581">
          <Card title="Contact Us" data-id="element-582">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-583">
              <ContactMethod icon={<MessageCircleIcon className="h-8 w-8" data-id="element-585" />} title="Live Chat" description="Chat with our support team" action="Start Chat" data-id="element-584" />
              <ContactMethod icon={<PhoneIcon className="h-8 w-8" data-id="element-587" />} title="Phone" description="+1 (800) 123-4567" action="Call Now" data-id="element-586" />
              <ContactMethod icon={<MailIcon className="h-8 w-8" data-id="element-589" />} title="Email" description="support@oxypay.com" action="Send Email" data-id="element-588" />
            </div>
            <div data-id="element-590">
              <h3 className="text-lg font-medium mb-4" data-id="element-591">Send us a message</h3>
              <form className="space-y-4" data-id="element-592">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-593">
                  <div data-id="element-594">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700" data-id="element-595">
                      Name
                    </label>
                    <input type="text" name="name" id="name" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" data-id="element-596" />
                  </div>
                  <div data-id="element-597">
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-598">
                      Email
                    </label>
                    <input type="email" name="email" id="email" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" data-id="element-599" />
                  </div>
                </div>
                <div data-id="element-600">
                  <label htmlFor="subject" className="block text-sm font-medium text-gray-700" data-id="element-601">
                    Subject
                  </label>
                  <select id="subject" name="subject" className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" data-id="element-602">
                    <option data-id="element-603">Account Issues</option>
                    <option data-id="element-604">Gift Card Inquiry</option>
                    <option data-id="element-605">Virtual Card Support</option>
                    <option data-id="element-606">Crypto Transaction</option>
                    <option data-id="element-607">Savings Account</option>
                    <option data-id="element-608">Bill Payment</option>
                    <option data-id="element-609">NIN Virtual Card</option>
                    <option data-id="element-610">Other</option>
                  </select>
                </div>
                <div data-id="element-611">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700" data-id="element-612">
                    Message
                  </label>
                  <textarea id="message" name="message" rows={4} className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" data-id="element-613"></textarea>
                </div>
                <div data-id="element-614">
                  <button type="submit" className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-615">
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </Card>
        </div>
        <div data-id="element-616">
          <Card title="Frequently Asked Questions" data-id="element-617">
            <div className="space-y-4" data-id="element-618">
              <FaqItem question="How do I sell my gift cards?" answer="Navigate to the Gift Cards page, select the brand you want to sell, enter the card details, and upload any required images. After verification, you'll receive payment to your Oxy Pay account." data-id="element-619" />
              <FaqItem question="Which African countries do you support for bill payments?" answer="Oxy Pay supports bill payments across all 54 African countries, including Nigeria, Kenya, South Africa, Ghana, and many more." data-id="element-620" />
              <FaqItem question="How do I generate a virtual NIN card?" answer="Go to the NIN Virtual page, enter your NIN number and personal details. After verification, you'll be able to download your virtual NIN card as a PDF file." data-id="element-621" />
              <FaqItem question="What cryptocurrencies do you support?" answer="We currently support Bitcoin (BTC), Ethereum (ETH), Solana (SOL), and Ripple (XRP). More cryptocurrencies will be added in the future." data-id="element-622" />
              <FaqItem question="How secure is Oxy Pay?" answer="Oxy Pay uses industry-standard encryption and security protocols to protect your data and transactions. We also employ multi-factor authentication to ensure account security." data-id="element-623" />
            </div>
          </Card>
          <Card title="Support Hours" className="mt-6" data-id="element-624">
            <div className="space-y-2" data-id="element-625">
              <div className="flex justify-between" data-id="element-626">
                <span className="text-gray-500" data-id="element-627">Monday - Friday</span>
                <span className="font-medium" data-id="element-628">8:00 AM - 8:00 PM</span>
              </div>
              <div className="flex justify-between" data-id="element-629">
                <span className="text-gray-500" data-id="element-630">Saturday</span>
                <span className="font-medium" data-id="element-631">9:00 AM - 5:00 PM</span>
              </div>
              <div className="flex justify-between" data-id="element-632">
                <span className="text-gray-500" data-id="element-633">Sunday</span>
                <span className="font-medium" data-id="element-634">Closed</span>
              </div>
              <div className="pt-2 mt-2 border-t border-gray-200" data-id="element-635">
                <span className="text-sm text-gray-500" data-id="element-636">
                  *All times are in Eastern Time (ET)
                </span>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>;
}
function ContactMethod({
  icon,
  title,
  description,
  action
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
  action: string;
}) {
  return <div className="border rounded-lg p-6 text-center" data-id="element-637">
      <div className="flex justify-center mb-4" data-id="element-638">
        <div className="p-2 bg-blue-100 rounded-full text-blue-600" data-id="element-639">{icon}</div>
      </div>
      <h3 className="text-lg font-medium" data-id="element-640">{title}</h3>
      <p className="text-gray-500 mb-4" data-id="element-641">{description}</p>
      <button className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-blue-700 bg-blue-100 hover:bg-blue-200" data-id="element-642">
        {action}
      </button>
    </div>;
}
function FaqItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 pb-2" data-id="element-643">
      <button className="w-full flex justify-between items-center py-2 text-left" onClick={() => setIsOpen(!isOpen)} data-id="element-644">
        <span className="text-sm font-medium text-gray-900" data-id="element-645">{question}</span>
        {isOpen ? <ChevronUpIcon className="h-5 w-5 text-gray-500" data-id="element-646" /> : <ChevronDownIcon className="h-5 w-5 text-gray-500" data-id="element-647" />}
      </button>
      {isOpen && <div className="pb-2" data-id="element-648">
          <p className="text-sm text-gray-500" data-id="element-649">{answer}</p>
        </div>}
    </div>;
}